module.exports = __webpack_public_path__ + "img/RJMT_insta.b07fa66e.svg";